import React, { useCallback } from 'react';
import LeaderboardRow from '../../leaderboard/LeaderboardRow';

/**
 * Card-style admin leaderboard rows (matches ClubPage list styling).
 */
export default function AdminLeaderboardList({ players = [], startRank = 1, onViewAnalysis }) {
  if (!players.length) {
    return (
      <p className="py-8 text-center text-sm text-text-muted">No players match the current filters.</p>
    );
  }

  return (
    <div className="space-y-2 sm:space-y-3">
      {players.map((player, index) => {
        const rank = startRank + index;
        const p = player.players;

        return (
          <AdminLeaderboardRow
            key={player.player_id}
            rank={rank}
            player={p}
            elo={player.current_elo}
            onViewAnalysis={onViewAnalysis}
            playerId={player.player_id}
          />
        );
      })}
    </div>
  );
}

function AdminLeaderboardRow({ rank, player, elo, playerId, onViewAnalysis }) {
  const handleViewAnalysis = useCallback(() => {
    if (!onViewAnalysis) return;
    onViewAnalysis({
      playerId,
      firstName: player?.first_name,
      lastName: player?.last_name,
      gender: player?.gender,
    });
  }, [onViewAnalysis, player, playerId]);

  const action = onViewAnalysis ? (
    <>
      <span className="text-text-muted/60" aria-hidden>·</span>
      <button
        type="button"
        onClick={handleViewAnalysis}
        className="text-xs font-medium text-primary/70 hover:text-primary hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 rounded-sm"
      >
        View analysis
      </button>
    </>
  ) : null;

  return (
    <LeaderboardRow
      rank={rank}
      player={player}
      elo={elo}
      action={action}
    />
  );
}
